import { type GradeCategory } from "@core/grades/types";
import { trans, plainTrans } from "@mongez/localization";
import { CategoryLessonsSection } from "./CategoryLessonsSection";

type CategoryChildLessonsProps = {
  categories: GradeCategory[];
};

export function CategoryChildLessons({
  categories,
}: CategoryChildLessonsProps) {
  if (!categories.length) return null;

  return (
    <div className="mt-12 space-y-14 border-t border-gray-200 pt-2 dark:border-gray-800">
      {categories.map((category) => (
        <CategoryLessonsSection
          key={category.id}
          description={trans("categoryDetails.chapterLessonsHint")}
          lessons={category.lessons || []}
          title={plainTrans("categoryDetails.chapterLessons", {
            chapter: category.name,
          })}
        />
      ))}
    </div>
  );
}
